import { Breadcrumb, Flex, Space, Tabs } from "antd";
import { MainLayout } from "components/layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import MasterDataManageRole from "./MasterDataManageRole";
import MasterDataAllWork from "./MasterDataAllWork";

const SettingTimesheetMasterData = ({
    rolePaginationList = [],
    onEdit = () => { },
    onRoleStatusChange = () => { },
    onPageChange = () => { },
    paginationRole = {},
    getStpTimeSheetRoleList = () => { },
    isLoading = false
}) => {
    const { t } = useTranslation();
    const [selectedMenu, setSelectedMenu] = useState('manage_role');
    const menuBreadcrumbMapping = {
        'manage_role': t('setting_timesheet.label.manage_role'),
        'all_work': t('setting_timesheet.label.all_work'),
    }

    const handleTabChange = (key) => {
        setSelectedMenu(key);
        if (key === "manage_role") {
            getStpTimeSheetRoleList({ page: 0, size: 10 })
        } else {
            console.log("all work");
        }
    }

    return (
        <MainLayout>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("setting_timesheet.header"), href: "" },
                        { title: t("masterdata.header"), href: "" },
                        { title: menuBreadcrumbMapping[selectedMenu] || null }
                    ]} />
                    <h2>{menuBreadcrumbMapping[selectedMenu] || null}</h2>
                </Flex>

                <Tabs destroyInactiveTabPane={true} defaultActiveKey="manage_role" onChange={handleTabChange}>
                    {
                        <Tabs.TabPane tab={t('setting_timesheet.label.manage_role')} key="manage_role">
                            <MasterDataManageRole
                                rolePaginationList={rolePaginationList}
                                onEdit={onEdit}
                                onRoleStatusChange={onRoleStatusChange}
                                onPageChange={onPageChange}
                                pagination={paginationRole}
                                isLoading={isLoading}
                            />
                        </Tabs.TabPane>
                    }
                    {/* {
                        <Tabs.TabPane tab={t('setting_timesheet.label.all_work')} key="all_work">
                            <MasterDataAllWork />
                        </Tabs.TabPane>
                    } */}
                </Tabs>
            </Space>
        </MainLayout>
    )
}

export default SettingTimesheetMasterData;